export const DATADOG_RUM_ACTIONS = {
  CRASHED_PAGE_VIEWED: 'crashed_page_viewed',
  DECAGON_COMPONENT_RENDERED: 'Decagon_Component_Rendered',
  DOM_MUTATION_PREVENTED: 'dom_mutation_prevented',
};

class DatadogRum {
  static hasLoaded = () => typeof window !== 'undefined' && window.DD_RUM;

  static addAction = (name, context) => {
    if (DatadogRum.hasLoaded()) {
      window.DD_RUM.onReady(() => {
        window.DD_RUM.addAction(name, context);
      });
    }
  };

  static addError = (error, context) => {
    if (DatadogRum.hasLoaded()) {
      window.DD_RUM.onReady(() => {
        window.DD_RUM.addError(error, context);
      });
    }
  };
}

export default Object.freeze(DatadogRum);
